module.exports = __webpack_public_path__ + "img/hinamori-logo-white-h.bc1b07cc.png";